Postlogin = (function (my) {
    Postlogin.AssessmentsProgressReport = {};
    const me = Postlogin.AssessmentsProgressReport;

    me.$reportResultsTable = $('#report-results-table');
    me.reportUrl = $('#report-select').find('option[value="AssessmentsProgressReport"]').data('report-url');
    me.exportUrl = $('#report-select').find('option[value="AssessmentsProgressReport"]').data('report-export-url');

    me.filters = ['user-license-ids', 'search-date', 'assigned-by', 'user-groups-single', 'completion-status', 'subtitle', 'user-grades'];

    me.setup = function () {
        $('.filter-column').each((index, element) => {
            const thisFilter = $(element);
            if (me.filters.includes(thisFilter.data('filter-name'))) {
                thisFilter.removeClass('hide');
            } else {
                thisFilter.addClass('hide');
            }
        });

        $('.search-date').find('.help-block').text('Limits the results for the assignment dates.');

        me.$reportResultsTable.bootstrapTable('destroy');
        $('#report-toolbar').hide();
    };

    me.runReport = function () {
        me.$reportResultsTable.addClass('sorting');
        $('body').css('cursor', 'progress');

        me.$reportResultsTable.bootstrapTable('destroy');
        me.$reportResultsTable.bootstrapTable(me.tableOptions);

        $('#report-toolbar').show();
    };

    me.exportReport = function () {
        const opts = $('#report-results-table').bootstrapTable('getOptions');
        const exportParams = me.getReportParams({
            columns: _.map($('#report-results-table').bootstrapTable('getVisibleColumns'), (col) => [col.title, col.field]),
            offset: 0,
            sort: opts.sortName,
            order: opts.sortOrder,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });

        const queryString = $.param(exportParams);
        window.open(`${me.exportUrl}?${queryString}`, '_blank');
    };

    me.initEvents = function () {
        //
    };

    me.getReportParams = function (params) {
        const searchParams = _.extend({}, params);
        searchParams.license_ids = $('#user-license-ids').val();
        searchParams.date = $('#search-date option:selected').val();
        searchParams.date_range_from = $('#search-start-date').val();
        searchParams.date_range_to = $('#search-end-date').val();
        searchParams.grades = $('#user-grades').val();
        searchParams.assessment_subtitle = $('#subtitle').val();
        searchParams.assigned_by = $('#assigned-by').val();
        searchParams.completion_status = $('#completion-status').val();
        searchParams.group_id = $('#user-groups-single').val();

        return searchParams;
    };

    me.progressBars = [];
    me.setupProgressBars = function () {
        if ($('.progress-indicator').length) {
            $('.progress-indicator').each(function () {
                const progress = $(this).attr('data-progress');
                const progressId = $(this).attr('data-progress-id');
                const indicatorBar = new ProgressBar.Line(`#${$(this).attr('id')}`, {
                    strokeWidth: 3,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#000',
                    trailColor: '#d9d9d9',
                    trailWidth: 3,
                    svgStyle: { width: '100%', height: '100%' },
                    from: { color: '#CDCD00' },
                    to: { color: '#1A9D5A' },
                    step(state, progressBar) {
                        progressBar.path.setAttribute('stroke', state.color);
                        progressBar.setText(`${Math.round(progressBar.value() * 100)} %`);
                    },
                });
                indicatorBar.animate(progress / 100); // Value from 0.0 to 1.0
                me.progressBars[progressId] = indicatorBar;
            });
        }
    };

    me.tableOptions = _.extend({}, Jr.reportsDataTable.options, {
        idField: 'user_id',
        url: me.reportUrl,
        toolbar: '#report-toolbar',
        queryParamsType: '',
        queryParams: (params) => me.getReportParams(params),

        onColumnSwitch() {
            me.setupProgressBars();
        },

        onLoadSuccess(data) {
            $('time.timeago').timeago();
            me.$reportResultsTable.removeClass('sorting');
            me.$reportResultsTable.closest('.bootstrap-table').find('.pagination-detail .duration').remove();
            me.$reportResultsTable
                .closest('.bootstrap-table')
                .find('.pagination-detail')
                .append(`<span class="duration">&nbsp;&nbsp;&nbsp;<em>(query took ${data.duration.toFixed(4)} seconds)</em></span>`);

            $('body').css('cursor', 'default');
            $('.app').removeClass('light-blur');
            $('#ajax-progress-indicator').fadeOut();

            me.setupProgressBars();
        },

        columns: [
            {
                title: 'Date Assigned',
                field: 'date_assigned',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    if (value) {
                        return new Date(value).toLocaleDateString('en-us');
                    }

                    return '-';
                },
            },
            {
                title: 'Subtitle',
                field: 'subtitle',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assigned By',
                field: 'assigned_by',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assigned To',
                field: 'assigned_to',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Progress',
                field: 'progress',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row, index) {
                    return `
                        <div class="progress-indicator hidden-print" id="student-progress-${index}"
                            data-progress="${row.progress}" data-progress-id="${index}">
                        </div>
                        <span class="visible-print">${row.progress}%</span>
                    `;
                },
            },
            {
                title: 'Date Started',
                field: 'date_started',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    if (value) {
                        return new Date(value).toLocaleDateString('en-us');
                    }

                    return '-';
                },
            },
            {
                title: 'Date Last Access',
                field: 'date_last_access',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    if (value) {
                        return new Date(value).toLocaleDateString('en-us');
                    }

                    return '-';
                },
            },
            {
                title: 'Date Completed',
                field: 'date_completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    if (value) {
                        return new Date(value).toLocaleDateString('en-us');
                    }

                    return '-';
                },
            },
        ],
    });

    return my;
}(Postlogin));
